import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicSharedModule } from '../../../public-shared/public-shared.module';
import { SharedModule } from '../../../../shared/shared.module';
import { BuyerInfoComponent } from './container/buyer-info/buyer-info.component';
import { NewGateLightboxComponent } from './components/new-gate-lightbox/new-gate-lightbox.component';
import { QRCodePopup } from './components/light-box-upg/light-box-upg.component';
import { PurchaseDoneComponent } from './components/purchase-done/purchase-done.component';
import { QassatlyDialogComponent } from './components/qassatly-dialog/qassatly-dialog.component';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { CreditCardPayComponent } from './components/credit-card-pay/credit-card-pay.component';
import { MatRadioModule } from '@angular/material/radio';
import { OtpPageComponent } from './components/otp-page/otp-page.component';
import { ReceiptComponent } from 'src/app/public-website/public-shared/receipt/receipt.component';
import { AmanInstallmentsComponent } from './components/aman-installments/aman-installments.component';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MogoComponent } from './components/mogo/mogo.component';
import { TruComponent } from './components/tru/tru.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ContactComponent } from './components/contact/contact.component';
import { InstapayOrderPaymentComponent } from './components/instapay-order-payment/instapay-order-payment.component';

const buyerInfoRoutes: Routes = [
  {
    path: '',
    component: BuyerInfoComponent,
  },
  {
    path: 'credit-card',
    component: CreditCardPayComponent,
  },
  {
    path: 'aman-options',
    component: AmanInstallmentsComponent,
  },
  {
    path: 'mogo-options',
    component: MogoComponent,
  },
  {
    path: 'tru-pay',
    component: TruComponent,
  },
  {
    path: 'contact-options',
    component: ContactComponent,
  },
];

@NgModule({
  declarations: [
    BuyerInfoComponent,
    NewGateLightboxComponent,
    PurchaseDoneComponent,
    QassatlyDialogComponent,
    CreditCardPayComponent,
    OtpPageComponent,

    AmanInstallmentsComponent,
    MogoComponent,
    TruComponent,
    QRCodePopup,
    InstapayOrderPaymentComponent,
    ContactComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(buyerInfoRoutes),
    PublicSharedModule,
    SharedModule,
    FormsModule,
    Ng2ImgMaxModule,
    MatRadioModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    QRCodeModule,
  ],
  exports: [
    InstapayOrderPaymentComponent
  ],
  providers: [ReceiptComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BuyerInfoModule {}
